
import { ElForm } from 'element-ui/types/form'
import { Component, Vue, Prop, Watch, Ref } from 'vue-property-decorator'

/**
 * 
 * @prop update     更新状态
 * @prop value      线索数据
 * @emit report     确认报道
 * 
*/
@Component({
    name: 'reportedDialog'
})
export default class extends Vue {
    @Prop({ required: true }) private value: any
    @Prop({ default: false }) private update!: boolean
    private dialogVisible = false
    private reportClueForm = {
        title: '',
        media: '',
        url: '',
        time: ''
    }
    private reportClueRules = {
        title: [
            { required: true }
        ],
        media: [
            { required: true, message: '请输入报道的媒体名' }
        ],
        time: [
            { required: true, message: '请选择报道的时间' }
        ]
    }
    private loading = false
    @Ref('reportClue') private reportClueRef!: ElForm

    @Watch('value')
    private watchVal(val: any) {
        this.reportClueForm.title = val.title
        this.reportClueForm.media = val.media || ''
        this.reportClueForm.time = val.time || ''
        this.reportClueForm.url = val.url || ''
    }

    // @Emit('report)
    private onReportClue() {
        this.reportClueRef.validate((isValid: boolean) => {
            if (!isValid) return
            const params = {
                medium_name: this.reportClueForm.media,
                published_at: this.reportClueForm.time,
                url: this.reportClueForm.url
            }
            if (this.update) {
                Reflect.set(params, 'id', this.value.id)
            } else {
                Reflect.set(params, 'clue_id', this.value.id)
            }
            this.loading = true
            this.$emit('report', params)
        })
    }

    private show() {
        this.stopLoading()
        this.dialogVisible = true
    }

    private hide() {
        this.stopLoading()
        this.reportClueRef.resetFields()
        this.dialogVisible = false
    }

    private stopLoading() {
        this.loading = false
    }
}
